import React, { useEffect } from "react"
import { ReactSVG } from "react-svg"

import { graphql } from "gatsby"
import { ArticleLargeKeyFigureFieldsFragment } from "../../../../../../graphql-types"

import * as styles from "./large-key-figure.module.scss"
import { elementOffset, transformItem } from "../../../functions/functions"

type LargeKeyFigureProps = {
  data: ArticleLargeKeyFigureFieldsFragment
}

const LargeKeyFigure: React.FC<LargeKeyFigureProps> = ({ data }) => {
  const displayImg = (image, style?): JSX.Element => {
    if (!image) return

    return image.format === "svg" ? (
      <ReactSVG className={style ? style : styles.image} src={image.url} title={image.title} />
    ) : (
      <img src={image.url} alt={image.alt || ""} title={image.title} className={style ? style : styles.image} />
    )
  }

  const handleScrollAnimation = () => {
    document.addEventListener("scroll", () => {
      const container = document.getElementsByClassName(data.hasImage ? styles.containerWithImage : styles.container)

      Array.from(container).forEach(artContainer => {
        if (window.scrollY >= elementOffset(artContainer).top - 700) {
          transformItem(
            artContainer.getElementsByClassName(data.hasImage ? styles.mainInfoWithImage : styles.mainInfo)[0],
            400
          )
          transformItem(artContainer.getElementsByClassName(styles.image)[0], 800)
        }
      })
    })
  }

  useEffect(() => {
    handleScrollAnimation()
  }, [])

  return (
    <section className={data.hasImage ? styles.containerWithImage : styles.container}>
      {data.hasImage && displayImg(data.image)}
      <div className={data.hasImage ? styles.mainInfoWithImage : styles.mainInfo}>
        <div className={data.hasImage ? styles.keyContainerWithImage : styles.keyContainer}>
          {data.hasIconLeft && displayImg(data.icon, styles.iconLeft)}
          <p className={styles.keyFigure}>{data.keyFigure}</p>
          {data.hasIconRight && displayImg(data.icon, styles.iconRight)}
        </div>
        <h4 className={styles.subtitle}>{data.subtitle}</h4>
        <p className={styles.description}>{data.description}</p>
      </div>
    </section>
  )
}

export const fragment = graphql`
  fragment ArticleLargeKeyFigureFields on DatoCmsArticleLargeKeyFigure {
    __typename
    id
    keyFigure
    subtitle
    description
    hasIconLeft
    hasIconRight
    hasImage
    icon {
      alt
      format
      title
      url
    }
    image {
      alt
      format
      title
      url
    }
  }
`

export default LargeKeyFigure
